"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsDateToMySQLDate = function (jsDate) {
    var month = String(jsDate.getMonth() + 1);
    if (month.length === 1) {
        month = "0" + month;
    }
    var day = String(jsDate.getDate());
    if (day.length === 1) {
        day = "0" + day;
    }
    var year = String(jsDate.getFullYear());
    return year + "-" + month + "-" + day;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZVRvU3RyaW5nLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2Z1bmN0aW9ucy9kYXRlVG9TdHJpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLGlCQUFpQixHQUFHLFVBQUMsTUFBWTtJQUMxQyxJQUFJLEtBQUssR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLFFBQVEsRUFBRSxHQUFHLENBQUMsQ0FBQyxDQUFBO0lBQ3pDLElBQUksS0FBSyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7UUFDcEIsS0FBSyxHQUFHLE1BQUksS0FBTyxDQUFBO0tBQ3RCO0lBQ0QsSUFBSSxHQUFHLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxPQUFPLEVBQUUsQ0FBQyxDQUFBO0lBQ2xDLElBQUksR0FBRyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7UUFDbEIsR0FBRyxHQUFHLE1BQUksR0FBSyxDQUFBO0tBQ2xCO0lBQ0QsSUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxXQUFXLEVBQUUsQ0FBQyxDQUFBO0lBQ3pDLE9BQVUsSUFBSSxTQUFJLEtBQUssU0FBSSxHQUFLLENBQUE7QUFDcEMsQ0FBQyxDQUFBIn0=